import { render, staticRenderFns } from "./TruckScheduleSlotView.vue?vue&type=template&id=bdd93890&scoped=true&"
import script from "./TruckScheduleSlotView.vue?vue&type=script&lang=js&"
export * from "./TruckScheduleSlotView.vue?vue&type=script&lang=js&"
import style0 from "./TruckScheduleSlotView.vue?vue&type=style&index=0&id=bdd93890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd93890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VBtn,VCalendar,VCard,VChip,VCol,VContainer,VIcon,VRow,VSelect,VToolbarTitle})
